/**
 * #1098 addendum 1 — post-update first boot: disk session before IPC/localStorage are ready.
 */

import { isConnectorAvailable } from '../lib/connector';
import { readSavedZoneId } from './zoneRestorePick';

const BOOT_HYDRATE_POLL_MS = 250; export const BOOT_HYDRATE_WAIT_MS = 30_000;
let bootHydrateGate: Promise<boolean> | null = null;

export function ensureBootSessionHydratedFromDisk(deadlineMs = BOOT_HYDRATE_WAIT_MS): Promise<boolean> {
  if (!bootHydrateGate) {
    bootHydrateGate = (async () => {
      if (!isConnectorAvailable()) return false;
      const deadline = Date.now() + deadlineMs;
      while (Date.now() < deadline) {
        if (readSavedZoneId()) return true;
        const disk = await import('./connectorLastPlaybackSession');
        const session = await disk.pullLastPlaybackSessionFromDisk();
        if (session) {
          disk.seedLocalStorageFromLastPlaybackSession(session);
          return true;
        }
        await new Promise((r) => setTimeout(r, BOOT_HYDRATE_POLL_MS));
      }
      return !!readSavedZoneId();
    })();
  }
  return bootHydrateGate;
}
